import PublicationBanner from "../../../components/PublicationBanner"

const PublicationsComponent = ({ Publications }: any) => {
  return (
    <div className="pt-10 pb-5 bg-gray-300">
      <div className="">
        <PublicationBanner content={Publications} />
      </div>
    </div>
  );
};

export default PublicationsComponent;